import React from "react";
import { useParams } from "react-router";

import { useAppSelector } from "../../hooks/store";
import { interfaceElementsSelector } from "../../store/slices/themeSlice";
import { INTERFACE_ELEMENTS } from "../../themes/constants";

import { FileList, Layout } from "../../components";
import { Center, Skeleton } from "../../components/ui";
import { useGetPackageQuery } from "../../store/api/package.api";
import { useGetAttractionQuery } from "../../store/api/attraction.api";

import styles from "./index.module.css";

const FilesPage = () => {
  const params = useParams();
  const packageQuery = useGetPackageQuery(params.package_id);
  const attractionQuery = useGetAttractionQuery(
    packageQuery.data?.attraction_id,
    {
      skip: !packageQuery.isSuccess,
    }
  );
  const interfaceElements = useAppSelector(interfaceElementsSelector);
  const hasHeader = interfaceElements.includes(INTERFACE_ELEMENTS.HEADER);

  return (
    <Layout>
      <Center>
        {attractionQuery.isLoading && (
          <Skeleton count={1} className={styles.skeletonLoader} />
        )}
        {attractionQuery.isSuccess && (
          <div
            className={
              hasHeader
                ? styles.fileListContainer
                : styles.fileListContainerNoHeader
            }
          >
            <FileList
              pack={packageQuery.data}
              attraction={attractionQuery.data}
            />
          </div>
        )}
      </Center>
    </Layout>
  );
};

export default FilesPage;
